import { RefreshCw } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/Button';
import { applyAppUpdate } from '@/lib/appUpdate';
import { useAppUpdateAvailable } from '@/hooks/useAppUpdateAvailable';

export function AppUpdateBanner() {
  const { t } = useTranslation();
  const updateAvailable = useAppUpdateAvailable();

  if (!updateAvailable) return null;

  return (
    <div
      role="status"
      className="z-50 flex shrink-0 flex-wrap items-center justify-between gap-3 border-b border-[var(--fv-primary)]/30 bg-[var(--fv-primary)] px-4 py-3 text-sm text-white"
    >
      <div className="flex min-w-0 items-start gap-3">
        <RefreshCw className="mt-0.5 h-5 w-5 shrink-0" aria-hidden />
        <div>
          <p className="font-semibold">{t('appUpdate.title')}</p>
          <p className="mt-0.5 opacity-90">{t('appUpdate.body')}</p>
        </div>
      </div>
      <Button
        type="button"
        variant="secondary"
        className="shrink-0 border-white/30 bg-white text-[var(--fv-primary)] hover:bg-white/90"
        onClick={() => void applyAppUpdate()}
      >
        {t('appUpdate.action')}
      </Button>
    </div>
  );
}
